(function(){"use strict";try{if(typeof document<"u"){var n=document.createElement("style");n.appendChild(document.createTextNode(`._playIcon_3xgwd_1{background:transparent;border:0 none;cursor:pointer;left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%)}._playIcon_3xgwd_1 span{border-radius:50%;color:var(--neu-plain-0);font-size:78px;transition-duration:.2s;transition-property:transform;font-variation-settings:normal}._playIcon_3xgwd_1:hover i,._playIcon_3xgwd_1:focus i{transform:scale(1.3)}._opacity_3xgwd_23{opacity:.77}
._extendedDropdown_17k1l_1 .unit-dropdown .dropdown-menu{max-height:clamp(150px,80vh,500px)!important}
@media (min-width: 992px){._overlay_1tz1r_2{margin-top:-6rem}}@media (min-width: 992px){._corpOverlay_1tz1r_8{margin-top:-8rem}}._hideEmpty_1tz1r_13:has(>div:empty){display:none}
._richText_1ghed_1 a:not(._neu-button_1ghed_1){color:var(--neu-plain-0);font-size:14px;text-decoration:none}._richText_1ghed_1 a:not(._neu-button_1ghed_1):hover,._richText_1ghed_1 a:not(._neu-button_1ghed_1):focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._richText_1ghed_1 strong{font-weight:600}._richText_1ghed_1 hr{border:none;background-color:var(--neu-plain-0);height:1px;width:100%;margin:20px 0}a._corpLinks_1ghed_24{color:var(--neu-plain-0);text-decoration:none}a._corpLinks_1ghed_24:hover,a._corpLinks_1ghed_24:focus{background:none;text-decoration:underline;color:var(--neu-plain-0);border:none}._containerFlex_1ghed_37{padding:35px}@media (min-width: 992px){._containerFlex_1ghed_37{padding:35px 72px}}
@media (min-width: 576px){._standaloneSearch_10kr5_2{min-width:20rem}}._standaloneSearch_10kr5_2 .unit-dropdown{width:100%}._standaloneSearch_10kr5_2 .neu-form--support:empty{display:none}._standaloneSearch_10kr5_2 .unit-wrapper:before{all:unset}._standaloneSearch_10kr5_2 .neu-form__native{padding:var(--form-padding);padding-right:calc(40px + var(--neu-spacer-3));min-width:18rem}._standaloneSearch_10kr5_2 .neu-form__native::-webkit-search-cancel-button{margin-top:.1rem}@media (min-width: 992px){._corporateStandalone_10kr5_25{min-width:19rem}._corporateStandalone_10kr5_25 label{color:var(--neu-plain-0)}}._standaloneSearch_10kr5_2+.input-spinner{--feedback-padding-right: calc(40px + var(--neu-spacer-3));--feedback-padding-bottom: var(--neu-spacer-3)}._standaloneButton_10kr5_37.with-label{top:calc(1.375rem + var(--neu-spacer-2))}`)),document.head.appendChild(n)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { jsxs as g, jsx as t, Fragment as j } from "react/jsx-runtime";
import { useRef as E } from "react";
import { c as s } from "./clsx.OuTLNxxd.js";
import { u as R } from "./use-sitecore-context.C7g4vcbm.js";
import { ConditionalWrap as T } from "../components/conditional-wrap/index.js";
import { NeuGrid as o } from "@hcahealthcaredpx/neutron-react";
import { Text as f, Link as z } from "@sitecore-jss/sitecore-jss-nextjs";
const N = ({
  description: n,
  title: e,
  className: m,
  headingLevel: d = "h2",
  children: r,
  hasLink: c,
  linkField: l,
  titleClassName: i = "fw-medium"
}) => {
  const a = c && l, p = !a && "text-center";
  return !e && !r && !n ? null : /* @__PURE__ */ g(o, { className: s(p, m), children: [
    /* @__PURE__ */ g(
      o.Row,
      {
        gutter: "none",
        className: s(
          "justify-content-start justify-content-lg-between align-items-start align-items-lg-end gap-3 gap-lg-0 mb-3"
        ),
        children: [
          e && /* @__PURE__ */ t(o.Column, { className: `col-12 ${a ? "col-lg-6" : ""}`, children: /* @__PURE__ */ t(f, { tag: d, field: e, className: i }) }),
          l && /* @__PURE__ */ t(o.Column, { className: "col-12 col-lg-6 text-lg-end", children: /* @__PURE__ */ t(z, { field: l }) })
        ]
      }
    ),
    n && /* @__PURE__ */ t(o.Row, { gutter: "none", children: /* @__PURE__ */ t(o.Column, { children: /* @__PURE__ */ t(f, { tag: "p", field: n }) }) }),
    r && /* @__PURE__ */ t(o.Row, { gutter: "none", children: /* @__PURE__ */ t(o.Column, { children: r }) })
  ] });
}, $ = "_overlay_1tz1r_2", L = "_corpOverlay_1tz1r_8", W = "_hideEmpty_1tz1r_13", u = {
  overlay: $,
  corpOverlay: L,
  hideEmpty: W
}, X = ({
  ref: n,
  className: e,
  onClick: m,
  dataTestId: d,
  title: r,
  description: c,
  headingLevel: l,
  disableContainer: i = !1,
  overlay: a,
  children: p,
  borderToggle: y,
  variant: h,
  conditionalWrapclassName: v = "d-flex flex-column gap-5 gap-lg-7",
  titleClassName: x = "fw-medium"
}) => {
  const {
    sitecoreContext: {
      siteAttributes: { isCorporate: w }
    }
  } = R(), _ = E(null), C = h === "white" && "neu-bg-plain-0", b = !!(r || c), S = !(e != null && e.includes("py-")) && !i;
  return /* @__PURE__ */ t(
    "section",
    {
      ref: n,
      className: s(
        S && "py-6",
        // TODO: fix hack when classnames are generated in the correct order
        y === "1" && "border-bottom border-neu-gray-20",
        C,
        "position-relative",
        u.hideEmpty,
        e
      ),
      "data-test-id": d,
      onClick: m,
      children: /* @__PURE__ */ t(
        T,
        {
          condition: !i,
          wrapper: (O) => /* @__PURE__ */ t(
            "div",
            {
              className: s(
                "container",
                v,
                a === "1" ? w ? `${u.corpOverlay}` : `${u.overlay}` : void 0
              ),
              ref: _,
              children: O
            }
          ),
          wrappedJSX: /* @__PURE__ */ g(j, { children: [
            !i && b && /* @__PURE__ */ t(
              N,
              {
                title: r,
                description: c,
                headingLevel: l,
                titleClassName: x
              }
            ),
            p
          ] })
        }
      )
    }
  );
};
export {
  X as S,
  N as a
};
